import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';

export const PAGE_TABS_URL_PARAM = 'pageTab';

export const appIdToPathnameMapNew = {
  [EvidencePlatformSidebarAppID.dataAdministration]:
    EvidencePlatformSidebarAppID.dataAdministration,
  [EvidencePlatformSidebarAppID.projects]: EvidencePlatformSidebarAppID.projects,
  [EvidencePlatformSidebarAppID.organizations]: EvidencePlatformSidebarAppID.organizations,
  [EvidencePlatformSidebarAppID.users]: EvidencePlatformSidebarAppID.users,
  [EvidencePlatformSidebarAppID.extractionAccuracy]:
    EvidencePlatformSidebarAppID.extractionAccuracy,
  [EvidencePlatformSidebarAppID.dataReliability]: EvidencePlatformSidebarAppID.dataReliability,
};
